export const profile = {
  block: {
    user_info: {
      title: 'Ваши данные'
    },

    company_info: {
      title: 'Информация о компании'
    },

    change_password: {
      title: 'Изменить пароль'
    }
  },

  form: {
    field: {
      email: {
        title: 'Электронный адрес',
        placeholder: ''
      },
      timezone: {
        title: 'Часовой пояс'
      },
      phone: {
        title: 'Номер телефона'
      },
      name: {
        title: 'Имя'
      },
      company: {
        title: 'Компания'
      },
      legal_name: {
        title: 'Юридическое лицо'
      },
      contract_number: {
        title: 'Номер контракта'
      },
      contract_date: {
        title: 'Дата контракта'
      },
      inn: {
        title: 'ИНН'
      },
      bank_details: {
        title: 'Банковские реквизиты'
      },
      password: {
        current: 'Пароль',
        new: 'Новый пароль',
        new_confirm: 'Повторите пароль'
      }
    }
  }
};
